import { ConfirmDialog } from 'lib/ConfirmDialog';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmAgeDialogProps {
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
}

export const ConfirmAgeDialog: React.FC<ConfirmAgeDialogProps> = ({ onConfirm, open, onClose }) => {
    const { t } = useTranslation();
    return (
        <ConfirmDialog
            title={t('OTT_AGE_MESSAGE_TITLE')}
            description={t('OTT_AGE_MESSAGE')}
            confirmMessage={t('OTT_AGE_CONFIRM')}
            cancelMessage={t('OTT_AGE_CANCEL')}
            onConfirm={onConfirm}
            onClose={onClose}
            open={open}
            disableEscapeKeyDown
            disableBackdropClick
        />
    );
};
